import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TargetCategoryName, isTargetCategoryName } from "../../types/TargetCategory";

interface DashboardState {
  targetCategory: TargetCategoryName;
}

const stored = localStorage.getItem("redux_targetCategory");

const initialState: DashboardState = {
  targetCategory: isTargetCategoryName(stored) ? stored : "Budget",
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setTargetCategory(state, action: PayloadAction<TargetCategoryName>) {
      state.targetCategory = action.payload;
      localStorage.setItem("redux_targetCategory", action.payload);
    },
  },
});

export const { setTargetCategory } = dashboardSlice.actions;
export default dashboardSlice.reducer;
